import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M11 3a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm6.657 1.929a1 1 0 1 1 1.414 1.414l-1.414 1.414a1 1 0 0 1-1.414-1.414zM4.929 6.343A1 1 0 0 1 6.343 4.93l1.414 1.414a1 1 0 0 1-1.414 1.414zM3 13a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2zm8 6a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm-4.657-2.757a1 1 0 0 1 1.414 1.414L6.343 19.07a1 1 0 0 1-1.414-1.414zm9.9 1.414a1 1 0 0 1 1.414-1.414l1.414 1.414a1 1 0 0 1-1.414 1.414zM19 13a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2z"
    }
  )
);
var SvgSpinnerOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SpinnerOutlined_default = SvgSpinnerOutlined;

export { SpinnerOutlined_default as default };
